module.exports = "/_next/static/images/clockalt-2a4a3284cca2c970d7463dcb8c350c9e.svg";